import { z } from 'zod';
import {
  useFrontendTool,
  type FrontendToolDefinition,
} from '@/hooks/useFrontendTool';

/** The PRODVIEW classification segments a list can narrow on. */
export interface ClassificationFilters {
  family?: string;
  group?: string;
  model?: string;
}

const params = z.object({
  family: z.string().optional(),
  group: z.string().optional(),
  model: z.string().optional(),
});

/**
 * One `filter_*_by_classification` tool over a list whose filters carry the
 * catalog Family / Group / Model segments; blank values clear a segment.
 */
export function useClassificationFilterTool<F extends ClassificationFilters>({
  name,
  description,
  filters,
  setFilters,
}: {
  name: string;
  description: string;
  filters: F;
  setFilters: (next: F) => void;
}): FrontendToolDefinition {
  return useFrontendTool({
    name,
    description,
    parameters: params,
    readOnlyHint: true,
    execute: ({ family, group, model }: z.infer<typeof params>) => {
      setFilters({
        ...filters,
        family: family?.trim() || undefined,
        group: group?.trim() || undefined,
        model: model?.trim() || undefined,
      });
      return { family, group, model };
    },
  });
}
